import { FrageDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/frage-display-model';
import { InfotextDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/infotext-display-model';
import { Directive, HostListener, Input } from '@angular/core';
import { StateService } from '@/core/services/state.service';
import { I18nService } from '@/core/services/i18nService';

@Directive({
  selector: '[appinfotextfrage]'
})
export class InfoTextFrageDirective {

  @Input("appinfotextfrage") frage: FrageDisplayModel | null = null;

  constructor(protected stateService: StateService, protected languageservice: I18nService) {    
  } 

  @HostListener('focus') onMouseEnter() {
    if(this.frage)
    {
      if(this.frage.texts)
      {
        let entry: InfotextDisplayModel = new InfotextDisplayModel();      
        entry.name = this.languageservice.getCurrentLocalizedTextDisplayModel(this.frage.texts)?.text ?? this.languageservice.instant('undefinedText');
        entry.beschreibung = this.frage.infotext;
        this.stateService.setFieldInfoText(entry);
      }
    }
  }
  
  @HostListener('blur') onMouseLeave() {
    this.stateService.clearFieldInfoText();
  }
}
